module.exports = __webpack_public_path__ + "static/media/program-learn-main-4.c2808c14.png";